import {
  HostEnvironment,
  PaldeskRemoteVersions,
} from '@paldesk/module-federation/core';

// used to make sure all environments have same properties
export class EnvironmentBase {
  static remotes: PaldeskRemoteVersions = {
    mfeJobPlanner: {
      environment: 'test',
      version: '2.*',
    },
  };
  static run_local_mfe = false;
  static native = false;
  static e2e_google_testcases = false;
  static environment: HostEnvironment = 'test';
  static is_demo_env = false;
  static buildId = '';
  static palfinger_api_management = '';
  static palfinger_api_management_subs_key = '';
  static palfinger_app_gateway = '';
  static palfinger_app_gateway_v2 = '';
  static palcode_public_api_key = '';
  static oidc_clientid = '';
  static oidc_scope = '';
  static alerts_polling_interval_seconds = '';
  static google_analytics_id = '';
  static google_api_key = '';
  static domainsForApiManagementSubsKey: string[] = [];
  static application_insights_key = '';

  static e2e_fleet_control_api = '';
  static e2e_mcl_api = '';

  static jobplanner_function_code = '';

  static LINKS: {
    SECURITY_TOKEN_SERVICE: string;
    POST_LOGOUT_REDIRECT_URI: string;
    EQUIPMENT_SCREEN: string;
    FLEET_MONITOR: string;
    OPERATOR_MONITOR: string;
    PALDESK_BASEPATH: string;
    PALFINGER_SURVEY: string;
    SALES_AND_SERVICE_SEARCH: string;
  } = {
    SECURITY_TOKEN_SERVICE: '',
    POST_LOGOUT_REDIRECT_URI: '',
    EQUIPMENT_SCREEN: '',
    FLEET_MONITOR: '',
    OPERATOR_MONITOR: '',
    PALDESK_BASEPATH: '',
    PALFINGER_SURVEY: '',
    SALES_AND_SERVICE_SEARCH: '',
  };

  static identityServerAuthConf: {
    whitelistedDomains: string[];
    whitelistedRoutes: string[];
  } = {
    whitelistedDomains: [],
    whitelistedRoutes: [],
  };
}
